import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppConstants } from '../commons/app-constants';
import { BetaService } from './beta/beta.service';
import { QualityService } from './quality/quality.service';
import { InventoryModuleService } from './inventory-module/inventory-module.service';
import { ReconciliationAccessService } from './reconciliation-access/reconciliation-access.service';
import { UserTimezoneService } from './user-timezone.service';
import { AiChatStatus } from './ai-chat/ai-chat.service';
import { OutdatedDoc, LegalAcceptanceStatus } from './legal.service';
import { CustomMadeAutoSuggestService } from './custom-made-auto-suggest/custom-made-auto-suggest.service';

export interface BootstrapResponse {
  beta: { betaMode: boolean };
  quality: { qualityEnabled: boolean };
  inventoryModule: { inventoryModuleEnabled: boolean };
  processModule: { processModuleEnabled: boolean };
  /** Optional: an older server does not send it (treated as enabled). */
  reconciliation?: { reconciliationEnabled: boolean };
  customMadeAutoSuggest: { customMadeAutoSuggestEnabled: boolean };
  aiChatStatus: AiChatStatus;
  timezone: { timezone: string };
  subscriptionStatus: any;
  legalOutdated: OutdatedDoc[];
  legalAcceptances: LegalAcceptanceStatus[];
}

// Fires the single GET /api/v1/bootstrap call that replaces the six separate
// per-navigation requests app.component.ts used to make, then fans the result
// out to each feature service's existing subject — no duplicate HTTP round trips.
@Injectable({ providedIn: 'root' })
export class BootstrapService {
  private readonly http = inject(HttpClient);
  private readonly betaService = inject(BetaService);
  private readonly qualityService = inject(QualityService);
  private readonly inventoryModuleService = inject(InventoryModuleService);
  private readonly reconciliationAccess = inject(ReconciliationAccessService);
  private readonly userTimezoneService = inject(UserTimezoneService);
  private readonly customMadeAutoSuggestService = inject(CustomMadeAutoSuggestService);

  load(): Observable<BootstrapResponse> {
    return this.http.get<BootstrapResponse>(`${AppConstants.API_URL}api/v1/bootstrap`).pipe(
      tap((res) => {
        this.betaService.setFromBootstrap(res.beta?.betaMode ?? false);
        this.qualityService.setFromBootstrap(res.quality?.qualityEnabled ?? false);
        this.inventoryModuleService.setFromBootstrap(res.inventoryModule?.inventoryModuleEnabled ?? false);
        this.reconciliationAccess.setFromBootstrap(res.reconciliation?.reconciliationEnabled ?? true);
        this.customMadeAutoSuggestService.setFromBootstrap(res.customMadeAutoSuggest?.customMadeAutoSuggestEnabled ?? false);
        this.userTimezoneService.set(res.timezone?.timezone || 'Asia/Kolkata');
      })
    );
  }
}
